import { useInfiniteQuery } from "@tanstack/react-query";
import klydoApiClient from "../../../api/klydo";
import { Label } from "../../../api/label";

const useKlydoLabelsQuery = (
  textSearch: string = "",
  limit: number = 20,
  sort?: Record<string, 1 | -1>,
) => {
  const fetchLabels = async (
    pageParam: {
      skip?: number;
      limit?: number;
    },
    query: string,
  ): Promise<Label[]> => {
    const { skip = 0, limit: pageLimit = limit } = pageParam;

    const result = await klydoApiClient.getKlydoLabels({
      query,
      skip,
      limit: pageLimit,
      sort,
    });

    return result;
  };

  const query = useInfiniteQuery<Label[], Error>({
    queryKey: ["klydo-labels", textSearch, limit, sort],
    queryFn: ({ pageParam }) =>
      fetchLabels({ ...(pageParam ?? { skip: 0, limit }) }, textSearch),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < limit) {
        return undefined;
      }
      const totalFetched = allPages.reduce((acc, page) => acc + page.length, 0);
      return { skip: totalFetched, limit };
    },
    initialPageParam: { skip: 0, limit },
  });

  return {
    ...query,
    data: query.data?.pages.flat() || [],
  };
};

export default useKlydoLabelsQuery;
